import type { MailContentProps, MailMetadata } from "../../lib/types";
import { MailSignature } from "../mail/mail-signature";

function MiseEnPlaceDemarcheRSE({ variablesData }: MailContentProps) {
  return (
    <div className="space-y-2">
      <p className="pb-4">
        {variablesData.genre_masc_complet}{" "}
        {variablesData.responsable_grand_est_precedent_nom},
      </p>
      <p>
        Nous vous rappelons notre proposition de mise en place d'une Démarche
        RSE dans votre entreprise.
      </p>
      <p>
        Notre récente étude montrait que bien qu'occupant une position de leader
        sur le marché, votre unité risquait de se voir distancée à court terme
        (deux ans maximum). Votre appareil de production est actuellement à sa
        capacité maximale, et faute de pouvoir réaliser dans l'immédiat les
        investissements indispensables en automatisation, il est nécessaire de
        renforcer la cohésion, la responsabilisation et la capacité de travail
        de vos équipes.
      </p>
      <p>
        Vous avez accepté la première partie de notre projet de formation.
        Celle-ci s'organise autour du déploiement de la RSE sur deux dimensions
        :
      </p>
      <ul className="list-disc pl-12">
        <li>
          La cohérence d'alignement des objectifs de la stratégie d'entreprise
          aux objectifs métiers
        </li>
        <li>
          La mobilisation de la direction générale, des managers et de
          l'ensemble des collaborateurs
        </li>
      </ul>
      <p>
        Il doit être suivi, dans une seconde partie, par l'implantation de cette
        logique dans chaque service.
      </p>
      <p>
        Nous restons à votre disposition pour toute information complémentaire
        et vous précisons que vous nous devez 22 867 € HT sur notre précédente
        intervention (facture AH/BCG-2/030783/F302).
      </p>
      <p>Cordialement.</p>
      <MailSignature
        emetteurLogo={MiseEnPlaceDemarcheRSE.metadata.emetteurLogo}
        emetteur={MiseEnPlaceDemarcheRSE.metadata.emetteur}
        emetteurPoste={MiseEnPlaceDemarcheRSE.metadata.emetteurPoste}
        emetteurEntreprise={MiseEnPlaceDemarcheRSE.metadata.emetteurEntreprise}
      />
    </div>
  );
}

MiseEnPlaceDemarcheRSE.metadata = {
  titre: "Mise en place Démarche RSE",
  cleMail: "mise_en_place_demarche_rse",
  messageTransfert: false,
  emetteur: "Jean Louis SENS",
  emetteurPoste: "Directeur",
  emetteurEntreprise: "Demos",
  emetteurLogo: "/logos/demos.png",
  dateRelative: 0,
  piecesJointes: ["projet-formation-demos"],
} as MailMetadata;

export default MiseEnPlaceDemarcheRSE;
